import React from "react";
import { Space, Input, Select } from "antd";
import { useTranslation } from "react-i18next";

import "../../../public/sass/components/_filters.scss";

const { Option } = Select;
const { Search } = Input;

export const Filters = ({ onSearch }) => {
  const { t, i18n } = useTranslation();


  return null;
  return (
    <div className="wrapper">
      <Space direction="horizontal" className="filters">
        <Select
          defaultValue={t("customer")}
          style={{ width: 110 }}
          className="filter-style"
        >
          <Option value="jack">Jack</Option>
          <Option value="lucy">Lucy</Option>
        </Select>
        <Select
          defaultValue="Status"
          style={{ width: 110 }}
          className="filter-style"
        >
          <Option value="jack">Jack</Option>
          <Option value="lucy">Lucy</Option>
        </Select>
        <Select
          defaultValue={t("action")}
          style={{ width: 110 }}
          className="filter-style"
        >
          <Option value="jack">Jack</Option>
          <Option value="lucy">Lucy</Option>
        </Select>
        <Search
          placeholder={t("search")}
          onSearch={onSearch}
          style={{ width: 110 }}
        />
      </Space>
    </div>
  );
};
